/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 利用可能機能
 * @export
 * @interface Function
 */
export interface Function {
    /**
     * 通番
     * @type {string}
     * @memberof Function
     */
    num?: string;
    /**
     * 機能ID
     * @type {string}
     * @memberof Function
     */
    functionId?: string;
    /**
     * 機能名
     * @type {string}
     * @memberof Function
     */
    functionName?: string;
}

/**
 * Check if a given object implements the Function interface.
 */
export function instanceOfFunction(value: object): value is Function {
    return true;
}

export function FunctionFromJSON(json: any): Function {
    return FunctionFromJSONTyped(json, false);
}

export function FunctionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Function {
    if (json == null) {
        return json;
    }
    return {
        
        'num': json['num'] == null ? undefined : json['num'],
        'functionId': json['functionId'] == null ? undefined : json['functionId'],
        'functionName': json['functionName'] == null ? undefined : json['functionName'],
    };
}

export function FunctionToJSON(value?: Function | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'num': value['num'],
        'functionId': value['functionId'],
        'functionName': value['functionName'],
    };
}

